import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { ReferenceDataAdviceStatusCssCategory } from '../constants/reference-data-advice-status-css-category';
import { ReferenceDataCaseStatusCategories } from '../constants/reference-data-case-status-categories';

@Directive({
  selector: '[boiCategorizeCaseStatus]'
})
export class CategorizeCaseStatusDirective implements OnInit, OnChanges {
  @Input() caseStatus: string;

  constructor(private readonly hostElement: ElementRef, private readonly renderer: Renderer2) {}

  ngOnInit(): void {
    this.addCaseStatusCssClass();
  }

  ngOnChanges(): void {
    this.addCaseStatusCssClass();
  }

  private addCaseStatusCssClass(): void {
    const cssClass =
      ReferenceDataCaseStatusCategories[this.caseStatus] !== undefined
        ? ReferenceDataCaseStatusCategories[this.caseStatus]
        : ReferenceDataAdviceStatusCssCategory[this.caseStatus];

    if (this.hostElement.nativeElement.className) {
      const classesToBeRemoved = this.hostElement.nativeElement.className.split(' ');
      classesToBeRemoved.forEach((classToBeRemoved: string) => {
        this.renderer.removeClass(this.hostElement.nativeElement, classToBeRemoved);
      });
    }

    const classesToBeAdded = cssClass ? cssClass.split(' ') : [];
    classesToBeAdded.forEach((classToBeAdded: string) => {
      this.renderer.addClass(this.hostElement.nativeElement, classToBeAdded);
    });
  }
}
